import { createContext } from "react";

import { ContactConnectionInfoDto } from "@hd/types/dto/contact/contact-connection-info.dto";
import { SignalrChatMessageDto } from "@hd/types/dto/contact/signalr-chat-message.dto";
import { SignalrRequestLockedDto } from "@hd/types/dto/contact/signalr-request-locked.dto";
import { SignalrRequestUnlockedDto } from "@hd/types/dto/contact/signalr-request-unlocked.dto";

interface HubContextType {
  subscribe: (
    companyId: number,
    hubCallbacks: HubContextCallbacks,
    customUserId?: string
  ) => Promise<void>;
  unsubscribe: (
    companyId: number,
    hubCallbacks: HubContextCallbacks,
    customUserId?: string
  ) => Promise<void>;
}

export interface HubContextCallbacks{
  onNewMessage?: (message: SignalrChatMessageDto) => void,
  onPersonStatusUpdated?: (message: ContactConnectionInfoDto) => void,
  onMessagesRead?: (messageIds: string[]) => void,
  onQuotationLocked?: (quotationData: SignalrRequestLockedDto) => void,
  onQuotationUnlocked?: (quotationData: SignalrRequestUnlockedDto) => void,
  onRequestLocked?: (quotationData: SignalrRequestLockedDto) => void,
  onRequestUnlocked?: (quotationData: SignalrRequestUnlockedDto) => void
}

export const HubContext = createContext<HubContextType>({
  subscribe: async () => {},
  unsubscribe: async () => {},
});
